import { startCase, uniqBy } from 'lodash';

import { GetExecutionResponse, getExecutionColumnKeysByType } from '@blockworks/platform/api/research/studio';

import { createOrdinalPalette } from '../components/charts/utils/ordinal-palette';

const getUniqueGroupByValues = ({
    execution,
    groupBy,
}: {
    execution: GetExecutionResponse['data'];
    groupBy: string;
}) => {
    if (!execution?.rows) return [];
    const { rows, metadata } = execution;

    if (!metadata?.columnTypes[groupBy]) {
        return [];
    }

    const uniqSyntheticColumns = uniqBy(rows, groupBy).map(row => row[groupBy]);
    return uniqSyntheticColumns;
};

const groupSeriesByColumn = ({
    execution,
    groupBy,
    initialSettings = { type: 'bar', axis: 'left', format: 'number', summary: 'sum' },
}: {
    execution: GetExecutionResponse['data'];
    groupBy: string;
    initialSettings?: Record<string, any>;
}) => {
    const uniqueGroupValues = getUniqueGroupByValues({ execution, groupBy });
    const availablePivotColumns = getExecutionColumnKeysByType(execution.metadata.columnTypes, 'number');
    const colors = createOrdinalPalette(uniqueGroupValues.length);

    if (availablePivotColumns.length === 0 || uniqueGroupValues.length === 0) {
        return null;
    }

    return {
        type: initialSettings.type,
        synthetic: availablePivotColumns[0],
        axis: {
            orientation: initialSettings.axis,
            format: initialSettings.format,
        },
        series: uniqueGroupValues
            .map((column, idx) => {
                const color = colors[idx];
                return {
                    ...initialSettings,
                    column: column,
                    label: startCase(column),
                    color: color,
                };
            })
            .sort((_, b) => {
                /** TODO: Not this */
                if (b.column.toLowerCase() === 'other') return -1;
                return 0;
            }),
    };
};

export { getUniqueGroupByValues, groupSeriesByColumn };
